import {createSelector} from 'reselect';
import {Types} from '../../Models/TerminalInstallationModel'
import {RootState} from 'Redux/Reducers/_RootReducer';
import {Types as UserTypes} from '../../Modules/UserModule'
import {OptionsElement} from 'Models/ViewManagementModel';
import {formValueSelector} from 'redux-form';
import moment from 'moment';
import {List} from 'immutable';
import * as TerminalInstallationModule from "Modules/TerminalInstallationModule";

export class TerminalInstallationSelectors {

    private static getElementById(elementList: Array<any>, idElement: number) {
        if (elementList.length > 0 && idElement != null) {
            const aciveEl: any = elementList.find((value) => {
                return value.id == idElement
            });
            return (aciveEl != -1) ? aciveEl : null;
        }

        return null;
    }

    /**
     * Selektor na podstawie listy instalaccji i id aktywnego zwraca obiekt aktywnego zlecenia montażu
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getActiveTerminalInstallation = createSelector(
        (state: RootState) => state.terminalInstallationStore.terminalInstallationOrderList,
        (state: RootState) => state.terminalInstallationStore.terminalInstallationOrderActive,
        TerminalInstallationSelectors.getElementById
    )

    /**
     * Selektor na podstawie listy instalaccji i id aktywnego zwraca obiekt aktywnego zlecenia montażu
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getTerminalInstallationHistoryComments = createSelector(
        (state: RootState) => state.terminalInstallationStore.terminalInstallationOrderList,
        (state: RootState) => state.terminalInstallationStore.historyCommentsId,
        TerminalInstallationSelectors.getElementById
    )


    /**
     * Selektor na podstawie listy monterów zwraca liste monterów {label,value}
     * (na potrzeby pola select)
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getTechnicianUserListForSelect = createSelector(
        (state: RootState) => [...state.terminalInstallationStore.technicians.toArray()],
        (technicianUserSelectList): Array<OptionsElement> => {
            if (technicianUserSelectList && technicianUserSelectList.length > 0) {
                return technicianUserSelectList.map((el: UserTypes.UserDto) => {
                    return {label: (el.firstName + ' ' + el.lastName), value: el.id}
                });
            }

            return [];
        }
    )

    /**
     * Selektor na podstawie listy monterów i installationDate wybranej w formularzu terminalInstallationListSetDateForm zwraca liste dostępnych monterów {label,value}
     * (na potrzeby pola select)
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getAvailableTechnicianUserListForSelect = createSelector(
        function (state: RootState) {
            return [...state.terminalInstallationStore.technicians.toArray()]
        },
        function (state: RootState) {
            return formValueSelector('terminalInstallationListSetDateForm')(state, 'installationDate')
        },
        (technicianUserSelectList, installationDate: moment.Moment): Array<OptionsElement> => {
            const tempTechnicianUserSelectList = [];
            if (technicianUserSelectList && technicianUserSelectList.length > 0) {
                technicianUserSelectList.forEach((el: UserTypes.UserDto) => {
                    if (
                      (installationDate == undefined)
                      || (el && el.insuranceEndDate && installationDate.isBefore(moment(el.insuranceEndDate).set({
                        hours: 23,
                        minutes: 59
                    })))) {
                        tempTechnicianUserSelectList.push({label: (el.firstName + ' ' + el.lastName), value: el.id});
                    }

                });
            }
            return tempTechnicianUserSelectList;
        }
    )


    /**
     * Selektor na podstawie obiektu terminalInstallationOneElement zwraca obiekt {technicianUser:{value,label},installationDate}
     * (na potrzeby ustawienia wartości domyślej formularza)
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getTerminalInstallationOneElementBySetDateForm = createSelector(
        (state: RootState) => state.terminalInstallationStore.terminalInstallationOneElement,
        (terminalInstallationOneElement): Types.SetDateTerminalInstallationForm => {
          if (terminalInstallationOneElement) {
            const installationDate = terminalInstallationOneElement.plannedInstallationDate ? moment(terminalInstallationOneElement.plannedInstallationDate) : null
                return {
                    technicianUser: (terminalInstallationOneElement.technician) ? {
                        value: terminalInstallationOneElement.technician.id,
                        label: (terminalInstallationOneElement.technician.firstName + ' ' + terminalInstallationOneElement.technician.lastName)
                    } : null,
                    installationDate
                }
            }

            return null;
        }
    )

    /**
     * Selektor na podstawie obiektu technicians i wartośći technicianUser formularza terminalInstallationListSetDateForm zwraca pełny obiekt montera
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getSelectedTechnician = createSelector(
        function (state: RootState) {
            return state.terminalInstallationStore.technicians.toArray()
        },
        function (state: RootState) {
            return formValueSelector('terminalInstallationListSetDateForm')(state, 'technicianUser')
        },
        (technicians: Array<UserTypes.UserDto>, technicianUser: OptionsElement): UserTypes.UserDto => {
            const technicianTemp = technicians.find(function (el) {
                return technicianUser && el.id == technicianUser.value;
            });

            if (technicianTemp != undefined) {
                return technicianTemp;
            }

            return null;
        }
    )

    /**
     * Selektor na podstawie listy instalacji i numeru vin zapisane w ContractStore zwraca obiekt instalacji powiązany z danym numerem vin
     *
     * @static
     * @memberof TerminalInstallationSelectors
     */
    public static getSelectedContractElementId = createSelector(
        function (state: RootState) {
            return state.terminalInstallationStore.terminalInstallationOrderList
        },
        function (state: RootState) {
            return state.contractStore.currentVin
        },
        (installationList: Array<TerminalInstallationModule.Types.TerminalInstallationOrderSimpleDto>, vin: string): number => {
            return installationList.find(el => el.vin === vin)?.id;
        }
    );

    public static getArrayFromList = createSelector(
        (list: List<any>) => list,
        (listToArray) => listToArray.toArray()
    )
}



// WEBPACK FOOTER //
// ./src/Redux/Selectors/TerminalInstallationSelectors.ts